import { AnalyticsEvent } from '@coach-bot/features/analytics';
import { Services } from '../services/services.service';
import { filter, firstValueFrom, take } from 'rxjs';

export async function sendServiceWorkerInitializedAnalyticsEvent(services: Services): Promise<void> {
  if (services.analyticsService.enabled) {
    await firstValueFrom(
      services.commonStore.profileEmail$.pipe(
        filter(email => !!email),
        take(1)
      )
    );
    const heartbeats: string[] = await services.heartbeatService.getHeartbeats();
    services.analyticsService.track(AnalyticsEvent.ServiceWorkerInitialized, {
      email: services.commonStore.profileEmail$.value,
      userId: services.commonStore.userId$.value || undefined,
      studentId: services.commonStore.studentId$.value || undefined,
      heartbeats: JSON.stringify(heartbeats),
    });
  }
}
